import { render, staticRenderFns } from "./ModalUser.vue?vue&type=template&id=0b467ac3&scoped=true"
import script from "./ModalUser.vue?vue&type=script&lang=js"
export * from "./ModalUser.vue?vue&type=script&lang=js"
import style0 from "./ModalUser.vue?vue&type=style&index=0&id=0b467ac3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b467ac3",
  null
  
)

export default component.exports